import { createContext, useContext } from "react";

/**
 * Ambient facts the hooks need but should not have to discover for themselves.
 *
 * Defaults are deliberately "safe without a provider": if `TxEngineProvider` is
 * not mounted (a test harness, a stray render outside the app tree), the hooks
 * still behave exactly like plain wagmi — they just do not get recovery.
 */
export const TxEngineContext = createContext({
  accountType: "eoa",
  isLeader: false,
  ready: false,
  /** Extra context handed to effect `send`/`verify` — socket, token, dispatch. */
  effectContext: {},
});

export function useTxEngine() {
  return useContext(TxEngineContext);
}
